<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row align-v="center" class="pb-2">
          <b-col cols="6">
            <span class="h5">{{ $t('dw.report.sale.header') }}</span>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-btn variant="success" @click="exportReport"><i class="fa fa-download mr-2"></i>{{$t('dw.general.export')}}</b-btn>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable keywordPlaceholder="Type to Search" searchAction="getSaleReport" vuexModule="Dw" type="dw" :filters="filters" :columns="columns" :autoSearchFilters="autoSearchFilters" v-model="currentFilters"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script type="text/javascript">
import { FITSearchableTable, FITFormCard } from '@/components'
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
import { domain } from '@/api/api.js'
import { saveAs } from 'file-saver/FileSaver';
import Cookies from 'js-cookie';

export default {
  name: 'reportSale',
  components: {
    FITSearchableTable,
    FITFormCard
  },
  computed: {
    ...mapGetters(['getTranslated']),
    ...mapState({
      vuexAllSelections: state => state.Dw.selections,
      selectedPolicyType: state => state.Dw.saleReport.policyType
    }),
    exportLink() {
      return `${domain}/report/sale?export=1&policyType=${this.currentFilters.type}`
    }
  },
  watch: {
    vuexAllSelections(newdata, oldData) {
      // console.debug(newdata);
      Vue.set(this, 'allSelections', newdata);
    },
    selectedPolicyType(newdata, oldData) {
      var type = 'life'
      if (newdata == 'G') {
        type = 'gi'
      }
      Vue.set(this, 'columns', this[type + 'Columns']);
    }
  },
  created() {
    Vue.set(this, 'columns', this['giColumns']);
    if (Cookies.get('permissionLevel') > 4) {
      Vue.set(this, 'autoSearchFilters', []);
    }
  },
  methods: {
    exportReport() {
      var filters = JSON.parse(JSON.stringify(this.currentFilters));
      filters.export = 1
      var params = this.$options.filters.removeEmptyObj(filters);
      console.debug(params);

      this.$store.dispatch('Dw/exportSaleReport', params).then((json) => {
        var fileName = json.headers['content-disposition'];
        fileName = fileName.split(' ').join('');
        fileName = fileName.split('attachment;filename=').join('');
        saveAs(new Blob([json.data]), fileName);
      })
    },
    setCurrentFilters(val) {
      Vue.set(this, 'currentFilters', val);
    },
    convertEnglishName(type, item) {
      var englishName = Vue.options.filters.isEmpty(item[type + 'EnglishFirstname']);
      if (englishName !== 'N/A') {
        englishName = item[type + 'EnglishLastname'] + ' ' + englishName;
      }
      return englishName;
    },
    convertChineseName(type, item) {
      var chineseName = Vue.options.filters.isEmpty(item[type + 'ChineseFirstname']);
      if (chineseName !== 'N/A') {
        chineseName = item[type + 'ChineseLastname'] + chineseName;
      }
      return chineseName;
    },
    getTranslatedValue(fieldName, key) {
      var obj = this.allSelections.filter((item) => { return item.name === fieldName });
      if (obj[0] == null) {
        if (key.length > 0) {
          return key
        }
        return 'N/A'
      }
      if (obj[0].options.length == 0) {
        return 'N/A';
      }
      var filteredType = this.getTranslated(this.$i18n.locale, 'Dw', fieldName).filter((item) => {
        return item.value === key
      });

      if (filteredType.length == 0) {
        return key
      }
      return filteredType[0].text
    },
  },

  data() {
    return {
      currentFilters: {},
      // exportLink: domain + '/report/sale?export=1',
      allSelections: [],

      filters: [{
          label: this.$t('dw.general.policyType'),
          key: 'policyType',
          type: 'select',
          default: 'G',
          haveAll: false,
        },
        {
          label: this.$t('dw.report.sale.policyStatus'),
          key: 'policyStatus',
          type: 'select',
          default: null,
          haveAll: true,
        }, {
          label: this.$t('dw.report.sale.applicationStartDate'),
          key: 'startDate',
          type: 'datetime',
          default: '',
        },
        {
          label: this.$t('dw.report.sale.applicationEndDate'),
          key: 'endDate',
          type: 'datetime',
          default: '',
        },

      ],
      columns: [],
      autoSearchFilters: [{
        label: this.$t('dw.general.agent'),
        key: 'agentID',
        searchParams: {
          placeholder: ' Type to search',
          dest: 'option',
          paras: [{ key: 'type', value: 'agent' }],
          showItems: ['englishFullname', 'chineseFullname', 'agentCode']
        }
      }, {
        label: this.$t('dw.general.team'),
        key: 'teamID',
        searchParams: {
          placeholder: ' Type to search',
          dest: 'option',
          paras: [{ key: 'type', value: 'team' }],
          showItems: ['teamCode']
        }
      }],
      lifeColumns: [{
          key: 'teamCode',
          sortable: true,
          label: this.$t('dw.general.teamCode'),
          formatter: (row, key, item) => {
            return Vue.options.filters.isEmpty(row);
          }
        },
        {
          key: 'agentCode',
          sortable: true,
          label: this.$t('dw.general.agentCode'),
          formatter: (row, key, item) => {
            return Vue.options.filters.isEmpty(row);
          }
        }, {
          key: 'agentName',
          label: this.$t('dw.general.agentName'),
          formatter: (row, key, item) => {
            return '<div>' + this.convertEnglishName('agent', item) + '</div>' +
              '<div>' + this.convertChineseName('agent', item) + '</div>'
          }
        },
        {
          key: 'policyNumber',
          label: this.$t('dw.report.sale.policyNumber'),
        },
        {
          key: 'providerCode',
          sortable: true,
          label: this.$t('dw.report.sale.provider'),
          tdClass: ['text-center'],
          thClass: ['text-center'],
          formatter: (row, key, item) => {
            return Vue.options.filters.isEmpty(row);
          }
        },
        {
          key: 'productName',
          label: this.$t('dw.report.sale.productName'),
          formatter: (row, key, item) => {
            return '<div>' + Vue.options.filters.isEmpty(item.productEnglishName) + '</div>' + '<div>' + Vue.options.filters.isEmpty(item.productChineseName) + '</div>'
          }
        },
        {
          key: 'policyOwner',
          label: this.$t('dw.report.sale.policyOwner'),
          formatter: (row, key, item) => {
            return '<div>' + this.convertEnglishName('owner', item) + '</div>' +
              '<div>' + this.convertChineseName('owner', item) + '</div>'
          }
        },
        {
          key: 'totalPremiums',
          sortable: true,
          label: this.$t('dw.report.sale.totalPremiums'),
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'fyp',
          sortable: true,
          label: this.$t('dw.report.sale.fyp'),
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'fyc',
          sortable: true,
          label: this.$t('dw.report.sale.fyc'),
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        }
      ],
      giColumns: [{
          key: 'teamCode',
          sortable: true,
          label: this.$t('dw.general.teamCode'),
          formatter: (row, key, item) => {
            return Vue.options.filters.isEmpty(row);
          }
        }, {
          key: 'agentCode',
          sortable: true,
          label: this.$t('dw.general.agentCode'),
          formatter: (row, key, item) => {
            return Vue.options.filters.isEmpty(row);
          }
        }, {
          key: 'agentName',
          label: this.$t('dw.general.agentName'),
          formatter: (row, key, item) => {
            return '<div>' + this.convertEnglishName('agent', item) + '</div>' +
              '<div>' + this.convertChineseName('agent', item) + '</div>'
          }
        },
        {
          key: 'policyNumber',
          label: this.$t('dw.report.sale.policyNumber'),
        },
        {
          key: 'providerCode',
          sortable: true,
          label: this.$t('dw.report.sale.provider'),
          tdClass: ['text-center'],
          thClass: ['text-center'],
          formatter: (row, key, item) => {
            return Vue.options.filters.isEmpty(row);
          }
        },
        {
          key: 'productName',
          label: this.$t('dw.report.sale.productName'),
          formatter: (row, key, item) => {
            return '<div>' + Vue.options.filters.isEmpty(item.productEnglishName) + '</div>' + '<div>' + Vue.options.filters.isEmpty(item.productChineseName) + '</div>'
          }
        },
        {
          key: 'policyOwner',
          label: this.$t('dw.report.sale.policyOwner'),
          formatter: (row, key, item) => {
            return '<div>' + this.convertEnglishName('owner', item) + '</div>' +
              '<div>' + this.convertChineseName('owner', item) + '</div>'
          }
        },

        {
          key: 'policyType',
          sortable: true,
          label: this.$t('dw.report.sale.policyType'),
          formatter: (row, key, item) => {
            return '<div>' + item.policyTypeEnglishName + '</div>' + '<div>' + item.policyTypeChineseName + '</div>'
          }
        },
        {
          key: 'premiumAmount',
          sortable: true,
          label: this.$t('dw.report.performance.premium'),
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        },
        {
          key: 'agentCommission',
          sortable: true,
          label: this.$t('dw.report.commission.faCommission'),
          formatter: (row, key, item) => {
            if (row != null && parseFloat(row) > 0) return '$ ' + parseFloat(row).toFixed(2);
            return '$ 0'
          }
        }
      ],
    }
  }
}

</script>
<style type="text/css">
.tableMinWidth120 {
  max-width: 120px;
}

.tableMinWidth150 {
  max-width: 150px;
}

</style>



// WEBPACK FOOTER //
// src/Dw/containers/ReportSale.vue